export default {
	AUTHENTICATION_TOKEN: "sso/api/v1/authentication-token",
	GET_PROCESS_INSTANCE_DATA: "/form/process-instances",
	SAVE_ACTIVITY: "/workflow-service/process-instances/business-data",
	CANCEL_PROCESS: "/workflow-service/process-instances/cancel",
	SHOW_ACTIVITY_FORM: "/form/start",
	COMPLETE_ACTIVITY: "/workflow-service/process-instances/complete-activity",
	FINISH_ACTIVITY: "/workflow-service/process-instances/finish",
	MARK_AS_READ: "/workflow-service/process-instances/mark-activity-as-read",
	DOWNLOAD_HELP_FILE: "/workflow-service/process-definitions/download-help-file",
	GET_USERS: "/workflow-service/users",
	GET_USER_BY_TICKET: "/workflow-service/ticket",
	GET_PUBLIC_FORM_USER: "/workflow-service/public-form/user",
	ASSIGN_ACTIVITY_TO_USER: "/workflow-service/process-instances/assign-activity-to-user",
	DOWNLOAD_JAVASCRIPT: "/javascript-service",
};
